import * as React from "react";
import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import axiosConfig from "./utils/axiosConfig";
import HeaderSubPage from "./partial/HeaderSubPage";
import {notify} from "./utils/utils";
import {ToastContainer} from "react-toastify";

export default function NewsletterUnsubscribe({partner}) {
    const [searchParams] = useSearchParams();
    const newsletterId = searchParams.get("id");
    const token = searchParams.get("token");
    const [status, setStatus] = useState(null);

    const doUnsubscribe = async () => {
        try {
            const response = await axiosConfig.get(`/newsletter/unsubscription?id=${newsletterId}&token=${token}`);
            setStatus(response.status)
        } catch (error) {
            notify("Der Newsletter-Link ist ungültig oder der Newsletter existiert nicht mehr.")
            throw error
        }
    }

    useEffect(() => {
        document.title = `${partner?.name} - Newsletter Abmeldung`;
        doUnsubscribe()
    }, []);
    return (
        <div>
            <ToastContainer/>
            <div className="site wrapper-content">
                <HeaderSubPage title={'Newsletter Abmeldung'}></HeaderSubPage>
                <section className="content-area">
                    <div className="container">
                        <div className="row">
                            <div className="site-main col-sm-12">
                                <h1>
                                    Newsletter Abmeldung
                                </h1>
                                {status === 200 ?
                                    (
                                        <p>
                                            Wir bedauern sehr, dass Sie sich von unserem Newsletter abgemeldet haben.
                                            Wunschgemäß
                                            haben wir Sie natürlich aus der Empfängerliste ausgetragen.
                                        </p>
                                    ) : (
                                        <p>
                                            Der Newsletter-Link ist ungültig oder der Newsletter existiert nicht mehr.
                                        </p>
                                    )
                                }

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
